import { render } from "./tentangKami.vue?vue&type=template&id=c9ad1f26"
import script from "./tentangKami.vue?vue&type=script&lang=js"
export * from "./tentangKami.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__